/** Base path for student self-service or parent viewing an approved child. */
export const studentPortalBase = (childStudentId) =>
  childStudentId != null ? `/parent/children/${childStudentId}` : '/student';

export const studentPortalOverviewPath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/overview`;

export const studentPortalWalletPath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/wallet`;

export const studentPortalWalletTopupInitiatePath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/wallet/topup/initiate`;

export const studentPortalWalletTopupVerifyPath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/wallet/topup/verify`;

export const studentPortalWalletTopupCompletePath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/wallet/topup/complete`;

export const studentPortalWalletReceiptPath = (childStudentId, txnId) =>
  `${studentPortalBase(childStudentId)}/wallet/receipt/${txnId}`;

export const studentPortalWalletAutopayPath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/wallet/autopay`;

export const studentPortalWalletAutopaySetupPath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/wallet/autopay/setup`;

export const studentPortalWalletAutopayCompletePath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/wallet/autopay/complete`;

export const studentPortalWhatsAppPreferencesPath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/whatsapp-preferences`;

export const studentPortalPlayingPath = (childStudentId) =>
  `${studentPortalBase(childStudentId)}/playing`;

export const sessionStatementExportPath = (childStudentId, { from, to }) =>
  `/api${studentPortalBase(childStudentId)}/reports/session-statement/export?from=${from}&to=${to}&format=pdf`;
